import React__default, { useMemo } from 'react';
import classNames from 'classnames';
import NvButton from '../../NvButton/NvButton.esm.js';
import { useTags } from '../NvTagsContext/useTags.esm.js';

var NvTagsInput = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.buttonAddText, buttonAddText = _c === void 0 ? '+' : _c, showClearButton = _a.showClearButton, readonly = _a.readonly;
    var _d = useTags(), tags = _d.tags, removeTag = _d.removeTag, removeAllTags = _d.removeAllTags, openModal = _d.openModal;
    var hasClearButton = useMemo(function () { return showClearButton && tags.length; }, [tags, showClearButton]);
    return (React__default.createElement("ul", { className: "nv-tags-wrapper" },
        tags.map(function (tag, index) { return (React__default.createElement("li", { className: classNames('nv-tags-tag', "nv-tags-".concat(size)), "data-testid": "tag-".concat(index), key: tag.id },
            React__default.createElement("p", { className: "nv-tags-label" }, tag.label),
            !readonly && (React__default.createElement("button", { className: "nv-tags-remove-button", "data-testid": "remove-button", onClick: function () { return removeTag(tag.id); }, type: "button" }, "\u00D7")))); }),
        !readonly && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("li", null,
                React__default.createElement(NvButton, { onClick: openModal, size: size, type: "button", variant: "secondary" }, buttonAddText)),
            React__default.createElement("li", null, !!hasClearButton && (React__default.createElement(NvButton, { className: "nv-tags-clear-button", onClick: removeAllTags, variant: "plain" }, "Clear all")))))));
};

export { NvTagsInput as default };
//# sourceMappingURL=NvTagsInput.esm.js.map
